var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stepLength"},[_c('p',[_vm._v("进度条：")]),_vm._v(" "),_c('van-progress',{staticStyle:{"width":"80%"},attrs:{"percentage":50}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }